module.exports = __webpack_public_path__ + "static/media/TW.2ed567a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/TW.svg
// module id = 380
// module chunks = 0